import { SET_ACTIVE_MENU, SET_LOGIN } from '../../constants';

export const setActiveMenu = (payload) => ({ type: SET_ACTIVE_MENU, payload });

